// Generated by scripts/mdi/import-questionnaires.mjs from MDI "PT-141 (Bremelanotide) INJECTION (Men and women) 09.17.26" (159366e4-7401-4824-b6f2-2ffd93e8008a). Re-run instead of editing.
import { FormType } from '../../../form-types';
import { mdiPT141BremelanotideInjectionMenAndWomenAnswerField } from './questions';

export const mdiPT141BremelanotideInjectionMenAndWomen: FormType<mdiPT141BremelanotideInjectionMenAndWomenAnswerField> =
  {
    name: 'PT-141 (Bremelanotide) INJECTION (Men and women)',
    validityLength: 25,
    questions: [
      'mdiPT141BremelanotideInjectionMenAndWomen_sex',
      {
        key: 'mdiPT141BremelanotideInjectionMenAndWomen_takingMedicationsPsychiatricConditionsE',
        next: {
          condition: {
            'mdiPT141BremelanotideInjectionMenAndWomen_takingMedicationsPsychiatricConditionsE.yes':
              true
          },
          key: 'mdiPT141BremelanotideInjectionMenAndWomen_listNameMedication',
          els: 'mdiPT141BremelanotideInjectionMenAndWomen_takingOpiateNarcoticMedications'
        }
      },
      'mdiPT141BremelanotideInjectionMenAndWomen_listNameMedication',
      {
        key: 'mdiPT141BremelanotideInjectionMenAndWomen_takingOpiateNarcoticMedications',
        next: {
          switch: [
            {
              condition: {
                'mdiPT141BremelanotideInjectionMenAndWomen_takingOpiateNarcoticMedications.yes':
                  true
              },
              key: 'mdiPT141BremelanotideInjectionMenAndWomen_listNameMedication2'
            },
            {
              condition: {
                'mdiPT141BremelanotideInjectionMenAndWomen_sex.female': true
              },
              key: 'mdiPT141BremelanotideInjectionMenAndWomen_pregnantTryingBecomePregnantBreastfeeding'
            },
            {
              condition: {
                'mdiPT141BremelanotideInjectionMenAndWomen_pregnantTryingBecomePregnantBreastfeeding.yes':
                  true
              },
              key: 'mdiPT141BremelanotideInjectionMenAndWomen_pregnancyBreastfeedingMedicallyUnsafe'
            }
          ],
          els: 'mdiPT141BremelanotideInjectionMenAndWomen_medicalConditions'
        }
      },
      {
        key: 'mdiPT141BremelanotideInjectionMenAndWomen_listNameMedication2',
        next: {
          switch: [
            {
              condition: {
                'mdiPT141BremelanotideInjectionMenAndWomen_sex.female': true
              },
              key: 'mdiPT141BremelanotideInjectionMenAndWomen_pregnantTryingBecomePregnantBreastfeeding'
            },
            {
              condition: {
                'mdiPT141BremelanotideInjectionMenAndWomen_pregnantTryingBecomePregnantBreastfeeding.yes':
                  true
              },
              key: 'mdiPT141BremelanotideInjectionMenAndWomen_pregnancyBreastfeedingMedicallyUnsafe'
            }
          ],
          els: 'mdiPT141BremelanotideInjectionMenAndWomen_medicalConditions'
        }
      },
      {
        key: 'mdiPT141BremelanotideInjectionMenAndWomen_pregnantTryingBecomePregnantBreastfeeding',
        next: {
          condition: {
            'mdiPT141BremelanotideInjectionMenAndWomen_pregnantTryingBecomePregnantBreastfeeding.yes':
              true
          },
          key: 'mdiPT141BremelanotideInjectionMenAndWomen_pregnancyBreastfeedingMedicallyUnsafe',
          els: 'mdiPT141BremelanotideInjectionMenAndWomen_medicalConditions'
        }
      },
      'mdiPT141BremelanotideInjectionMenAndWomen_pregnancyBreastfeedingMedicallyUnsafe',
      {
        key: 'mdiPT141BremelanotideInjectionMenAndWomen_medicalConditions',
        next: {
          condition: {
            'mdiPT141BremelanotideInjectionMenAndWomen_medicalConditions.yes':
              true
          },
          key: 'mdiPT141BremelanotideInjectionMenAndWomen_imSorryDueMedicalConditions',
          els: 'mdiPT141BremelanotideInjectionMenAndWomen_experiencedFrequentNauseaVomitingMotion'
        }
      },
      'mdiPT141BremelanotideInjectionMenAndWomen_imSorryDueMedicalConditions',
      'mdiPT141BremelanotideInjectionMenAndWomen_experiencedFrequentNauseaVomitingMotion',
      {
        key: 'mdiPT141BremelanotideInjectionMenAndWomen_takingSpecificMedicationsHighBlood',
        next: {
          switch: [
            {
              condition: {
                'mdiPT141BremelanotideInjectionMenAndWomen_takingSpecificMedicationsHighBlood.beta_blockers_e_g_metoprolol_atenolol_pr':
                  true
              },
              key: 'mdiPT141BremelanotideInjectionMenAndWomen_imSorryDueCurrentMedications'
            },
            {
              condition: {
                'mdiPT141BremelanotideInjectionMenAndWomen_takingSpecificMedicationsHighBlood.diuretics_e_g_furosemide_hydrochlorothia':
                  true
              },
              key: 'mdiPT141BremelanotideInjectionMenAndWomen_imSorryDueCurrentMedications'
            },
            {
              condition: {
                'mdiPT141BremelanotideInjectionMenAndWomen_takingSpecificMedicationsHighBlood.nitrate_medications_e_g_nitroglycerin_is':
                  true
              },
              key: 'mdiPT141BremelanotideInjectionMenAndWomen_imSorryDueCurrentMedications'
            }
          ],
          els: 'mdiPT141BremelanotideInjectionMenAndWomen_lastTimePersonMedicalEvaluation'
        }
      },
      'mdiPT141BremelanotideInjectionMenAndWomen_imSorryDueCurrentMedications',
      'mdiPT141BremelanotideInjectionMenAndWomen_lastTimePersonMedicalEvaluation',
      'mdiPT141BremelanotideInjectionMenAndWomen_importantClickAttachedLinkReview',
      'mdiPT141BremelanotideInjectionMenAndWomen_readAboutPt141Bremelanotide',
      'mdiPT141BremelanotideInjectionMenAndWomen_firstMessageDoctor',
      'mdiPT141BremelanotideInjectionMenAndWomen_complete'
    ]
  };
